import React from 'react'
import './ui.css'

const ACCENTS = ['left', 'success', 'warning', 'error']

/**
 * Карточка по новой DS (ds-card). accent: left | success | warning | error — полоска слева.
 */
function Card ({
  hover = false,
  accent,
  children,
  className = '',
  ...props
}) {
  const acc = ACCENTS.includes(accent) ? accent : null
  const accentClass = acc
    ? acc === 'left'
      ? ' ds-card-accent-left'
      : ` ds-card-accent-${acc}`
    : ''
  return (
    <div
      className={`ds-card${hover ? ' ds-card-hover' : ''}${accentClass}${className ? ` ${className}` : ''}`}
      {...props}
    >
      {children}
    </div>
  )
}

function CardHeader ({ children, className = '' }) {
  return (
    <div className={`ds-card-header ${className}`.trim()}>{children}</div>
  )
}

Card.Header = CardHeader

export default Card
